
import makerjs from "makerjs";
/**
 * 计算两点间的弦长
 * @param {Object} p1 - 第一个点坐标 {x, y}
 * @param {Object} p2 - 第二个点坐标 {x, y}
 * @returns {number} 弦长值
 */
 function calculateChordLength(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx*dx + dy*dy);
}
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;

  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
    x: midX + h * ux,
    y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;

  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);

  return {
    x: center.x + sumX * invLen,
    y: center.y + sumY * invLen
  };
}
function C19(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
    R1 = Param[0].param, R2 = Param[1].param, A = Param[2].param,  
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    r1 = R1 * 1 * myZoom,
    r2 = R2 * 1 * myZoom,
    a = A * 1 * myZoom,
    radian=a*Math.PI/180,
    // x0 = X*1*myZoom,
    // y0 = Y*1*myZoom;
    rh=r1*Math.sin(radian),rw=r1*Math.cos(radian),
    rh0=r2*Math.sin(radian),rw0=r2*Math.cos(radian),
    rha0=r2/4*Math.cos(radian),rwa0=r2/4*Math.sin(radian),
    h=rh,w=r1,
    x0 = rh0,  y0 = rw0,
    x1 = rh, y1 = rw,
    x2 = r1,  y2 = 0, 
    x3 = r2,  y3 = 0,   
    ox=0,oy=0,
    rxa0=rwa0,rya0=rha0,

    markLeftW1Rx=3*markShift*Math.cos(radian),
    markLeftW1Ry=3*markShift*Math.sin(radian),

    glassH = h, glassW = w;
 
 

  if (r1 !== 0) {
    var TxtR1 = "R1=" +R1;
  } if (r2 !== 0) {
    var TxtR2 ="R2=" + R2;
  } if (a !== 0) {
    var TxtA = "A=" + A;
  }



  var drawAbnormalShapeC19 = {
    paths: {
      "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
      "RightArcLine": new makerjs.paths.Arc([x1, y1], [x2, y2], r1, false, true),
      "BottomLine": new makerjs.paths.Line([x2, y2], [x3, y3]),      
      "LeftArcLine": new makerjs.paths.Arc([x0, y0], [x3, y3], r2, false, true),
    }
  };
  var drawAbnormalShapeC19MarkA = {
    paths: {
      
      "ArcLine": new makerjs.paths.Arc([rxa0, rya0], [r2/4, 0], r2/4, false, true),
    }
  };
  var drawAbnormalShapeC19MarkR1 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([ox, oy - markShift], [x2, y2 - markShift]),
      "BotmShortLfline": new makerjs.paths.Line([ox, oy], [ox, oy - 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
    }
  };
  var drawAbnormalShapeC19MarkR2 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([ox-markLeftW1Rx/2, oy+markLeftW1Ry/2], [x1-markLeftW1Rx/2, y1+markLeftW1Ry/2]),
      "BotmShortLfline": new makerjs.paths.Line( [ox, oy],[ox-markLeftW1Rx, oy+markLeftW1Ry]),
      "BotmShortRTline": new makerjs.paths.Line([x1, y1], [x1-markLeftW1Rx, y1+markLeftW1Ry]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC19MarkR1, TxtR1, [ox, oy - 3*markShift], [x2, y2 - 3*markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC19MarkA, TxtA, [r2/4+markShift, rya0/2], [r2/4+ 5 * markShift, rya0/2]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC19MarkR2, TxtR2, [ox-markLeftW1Rx, oy+markLeftW1Ry], [x1-markLeftW1Rx, y1+markLeftW1Ry]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC19: drawAbnormalShapeC19,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC19: drawAbnormalShapeC19,
      drawAbnormalShapeC19MarkR1: drawAbnormalShapeC19MarkR1,
      drawAbnormalShapeC19MarkA: drawAbnormalShapeC19MarkA,
      drawAbnormalShapeC19MarkR2: drawAbnormalShapeC19MarkR2,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C19;